<!-- 
  @desc 赛事名录管理
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-col :span="24"> <title-bar :titleBar="'赛事名录管理'"></title-bar></el-col>
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <el-col :span="4">
          <el-input placeholder="赛事名称" size="small" v-model="DirectoryPageListVO.name"></el-input>
        </el-col>
        <el-col :span="20" align="left">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getDirectoryGamePageList">
            查询
          </el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" class="table" fit stripe size="small" border v-loading="loading">
        <el-table-column label="赛事名称" align="left" prop="name"></el-table-column>
      </el-table>
      <Page :total="total" @current-change="changePage" />
    </el-container>
  </el-container>
</template>
<script>
import { DirectoryPageListVO } from "@/libs/model";
import TitleBar from "@/components/public/TitleBar.vue";
import Page from "@/components/public/Page.vue";
export default {
  components: {
    TitleBar,
    Page
  },
  data() {
    return {
      loading: false,
      total: 0,
      /**表格数据 */
      tableData: [],
      DirectoryPageListVO: new DirectoryPageListVO()
    };
  },
  created() {
    this.getDirectoryGamePageList();
  },
  methods: {
    /**获取赛事名录列表 */
    getDirectoryGamePageList() {
      this.loading = true;
      this.$http.directoryGamePageList(this.DirectoryPageListVO).then(response => {
        var res = this.$http.data(response);
        this.loading = false;
        if (res.status === "SUCCESS") {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    /** 页码变化 */
    changePage(val) {
      this.DirectoryPageListVO.page = val;
      this.getDirectoryGamePageList();
    }
  }
};
</script>
